import React, { useState, useEffect, useMemo } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/Button Triangle.png";
import FilterIcon from "../../assets/Icons/Orange Filter.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import Dropdown from "../Dropdown";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";

const PickupAddressFilterModal = ({
  show,
  handleClose,
  filterData,
  setFilterData,
  handleReset,
  pickupList = [],
  applyFilters,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      addressTitle: filterData?.addressTitle || "",
      phone: filterData?.phone || "",
    },
    mode: "onChange",
  });

  const watchedValues = watch();

  useEffect(() => {
    if (show) {
      reset({
        addressTitle: filterData?.addressTitle || "",
        phone: filterData?.phone || "",
      });
    }
  }, [show, filterData, reset]);

  const [selectedTab, setSelectedTab] = useState("Address Title");
  const [loading, setLoading] = useState(false);
  const [allPickupAddresses, setAllPickupAddresses] = useState([]);
  const loggedInUserName = sessionStorage.getItem("username");

  useEffect(() => {
    fetchAllAddresses();
  }, []);

  const fetchAllAddresses = async () => {
    try {
      const response = await axiosPostApi(
        `${apiList.FETCH_PICKUPADDRESS}?pageSize=1000&pageNo=1`,
        { username: loggedInUserName }
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00" &&
        Array.isArray(response?.data?.data)
      ) {
        setAllPickupAddresses(response.data.data);
      }
    } catch (err) {
      console.error(
        "Error fetching all pickup addresses for filter dropdowns:",
        err
      );
    }
  };

  // Address Title options (A-Z sorted, unique)
  const combinedAddressTitles = useMemo(() => {
    const titleSet = new Set();

    if (Array.isArray(allPickupAddresses)) {
      allPickupAddresses.forEach((item) => {
        const title = item?.addressTitle;
        if (title && typeof title === "string" && title.trim()) {
          titleSet.add(title.trim());
        }
      });
    }

    if (Array.isArray(pickupList)) {
      pickupList.forEach((item) => {
        const title = item?.addressTitle;
        if (title && typeof title === "string" && title.trim()) {
          titleSet.add(title.trim());
        }
      });
    }

    const list = Array.from(titleSet);
    list.sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: "base", numeric: true })
    );
    return list;
  }, [allPickupAddresses, pickupList]);

  const currentAddressTitle =
    watchedValues?.addressTitle || filterData?.addressTitle || "";

  const addressTitleOptions = useMemo(() => {
    const list = combinedAddressTitles.map((title) => ({
      label: title,
      value: title,
    }));

    if (currentAddressTitle) {
      return [
        { label: "✕ Clear Address Title Selection", value: "" },
        ...list,
      ];
    }
    return list;
  }, [combinedAddressTitles, currentAddressTitle]);

  // Phone No options (numeric/alphanumeric sorted, unique)
  const combinedPhoneNumbers = useMemo(() => {
    const phoneSet = new Set();

    if (Array.isArray(allPickupAddresses)) {
      allPickupAddresses.forEach((item) => {
        const phone = item?.phone;
        if (phone && typeof phone === "string" && phone.trim()) {
          phoneSet.add(phone.trim());
        }
      });
    }

    if (Array.isArray(pickupList)) {
      pickupList.forEach((item) => {
        const phone = item?.phone;
        if (phone && typeof phone === "string" && phone.trim()) {
          phoneSet.add(phone.trim());
        }
      });
    }

    const list = Array.from(phoneSet);
    list.sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: "base", numeric: true })
    );
    return list;
  }, [allPickupAddresses, pickupList]);

  const currentPhone = watchedValues?.phone || filterData?.phone || "";

  const phoneDropdownOptions = useMemo(() => {
    const list = combinedPhoneNumbers.map((phone) => ({
      label: phone,
      value: phone,
    }));

    if (currentPhone) {
      return [
        { label: "✕ Clear Phone No Selection", value: "" },
        ...list,
      ];
    }
    return list;
  }, [combinedPhoneNumbers, currentPhone]);

  const hasActiveFilter = (tabName) => {
    switch (tabName) {
      case "Address Title":
        return Boolean(
          filterData?.addressTitle && filterData.addressTitle.trim() !== ""
        );
      case "Phone No":
        return Boolean(filterData?.phone && filterData.phone.trim() !== "");
      default:
        return false;
    }
  };

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const onSubmit = (formData) => {
    setFilterData(formData);
    if (applyFilters) {
      applyFilters(formData);
    }
    handleClose();
  };

  const onReset = () => {
    const emptyFilters = {
      addressTitle: "",
      phone: "",
    };
    reset(emptyFilters);
    setFilterData(emptyFilters);
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <div className="flex items-center gap-2">
                  <img src={FilterIcon} alt="filter icon" className="w-6 h-6" />
                  <h5 className="modal-title main-title">Filter</h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="close icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {["Address Title", "Phone No"].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                            style={
                              hasActiveFilter(tab) && selectedTab !== tab
                                ? {
                                    outline: "2px solid #FF6B35",
                                    outlineOffset: "2px",
                                  }
                                : {}
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content !bg-[linear-gradient(to_bottom,#FFE8D4_0%_100%,transparent_25%_100%)]">
                      {/* Address Title Tab */}
                      {selectedTab === "Address Title" && (
                        <Controller
                          name="addressTitle"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Address Title</label>
                              <div className="dateInputWrapper">
                                <Dropdown
                                  placeholder="Select Address Title"
                                  options={addressTitleOptions}
                                  value={
                                    field.value ||
                                    watchedValues?.addressTitle ||
                                    filterData?.addressTitle ||
                                    ""
                                  }
                                  labelKey="label"
                                  valueKey="value"
                                  showSearch={true}
                                  selectClassName="!h-[38px] !rounded-[6px]"
                                  onChange={(item) => {
                                    const selectedTitle =
                                      item && item.value ? item.value : "";
                                    field.onChange(selectedTitle);
                                    setValue("addressTitle", selectedTitle);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      addressTitle: selectedTitle,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {/* Phone No Tab */}
                      {selectedTab === "Phone No" && (
                        <Controller
                          name="phone"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Phone No</label>
                              <div className="dateInputWrapper">
                                <Dropdown
                                  placeholder="Select Phone No"
                                  options={phoneDropdownOptions}
                                  value={
                                    field.value ||
                                    watchedValues?.phone ||
                                    filterData?.phone ||
                                    ""
                                  }
                                  labelKey="label"
                                  valueKey="value"
                                  showSearch={true}
                                  selectClassName="!h-[38px] !rounded-[6px]"
                                  onChange={(item) => {
                                    const selectedPhone =
                                      item && item.value ? item.value : "";
                                    field.onChange(selectedPhone);
                                    setValue("phone", selectedPhone);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      phone: selectedPhone,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back w-[133px] !rounded-lg"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit w-[133px] !rounded-lg"
                      disabled={isSubmitting}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Apply"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PickupAddressFilterModal;
